import React, {useState, useContext} from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  Container,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from '@material-ui/core/'
import CloseIcon from '@material-ui/icons/Close'
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import {barcodeSettingQuery} from '../../graphql/barcode/queries/barcodeSettingsQuery'
import {Query} from 'react-apollo'
import LoadingScreen from '../BarcodeLoadingScreen'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeTemplateDrawer.styles'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {ToastMessageContext} from '../../context/ToastMessage'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

export default function BarcodeTemplateDrawer(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const accountID = parseInt(window.localStorage.getItem('account_id'))
  const [barcodeValue, setBarcodeValue] = useState('')
  const [barcodeData, setBarcodeData] = useState([])
  const [generateLink, setGenerateLink] = useState('')
  const [selectedRecord, setSelectedRecord] = useState('')
  const {setBarcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {setBarcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const toast = useContext(ToastMessageContext)
  const currentUser = React.useContext(UserContext)

  function closeDrawer(event) {
    props.toggleDrawer(false)
  }

  function drawerTitle() {
    let title = 'Choose Template'
    let subTitle =
      'Choose a template that you have already created in the past and go straight to generating your PDF'

    return (
      <div>
        <Typography variant="h6">{title}</Typography>
        <Box fontSize={12} fontWeight={200} marginTop={2} marginBottom={3}>
          {subTitle}
        </Box>
      </div>
    )
  }

  const handleChange = event => {
    setBarcodeValue(event.target.value)
    let record = ''
    record = barcodeData[parseInt(event.target.value)]
    if (record.dataSource === 'from_objects') {
      setGenerateLink('barcode-wizard-generate-field-value')
    } else if (props.reprint) {
      setGenerateLink('barcode-libray-reprint-generate-automatic')
    } else {
      setGenerateLink('barcode-libray-generate-automatic')
    }
    setSelectedRecord(record)
  }

  function redirectBarcodeGenerate(event) {
    if(!validateBarcodePermission(currentUser, "can_generate"))
    {
      return;
    }
    if (barcodeValue === '') {
      toast.popMessage('Please Choose a Template!', 'warning', event.currentTarget)
    } else {
      setBarcodeSheetRecord(selectedRecord.sheet)
      setBarcodeLabelRecord(selectedRecord.label)
      props.toggleDrawer(false)
      document.getElementById('generate-redirect').click()
    }
  }

  function checkTemplate(data) {
    if (props.template) {
      data.map((record, index) => {
        if (record.id === props.template.id) {
          setSelectedRecord(record)
          return setBarcodeValue(`${index}unique`)
        }
        return ''
      })
    }
  }

  return (
    <div className={classes.list} role="presentation">
      <Grid container>
        <Grid container item xs={9} justify="flex-start">
          <Button className={classes.backBtn} onClick={closeDrawer}>
            <ArrowLeftIcon />
            {t('barcode.wizard.template-drawer.back-to-wizard')}
          </Button>
        </Grid>

        <Grid container item xs={3} justify="flex-end">
          <IconButton className={classes.buttonLink} onClick={closeDrawer}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Container>
        {drawerTitle()}
        <Query query={barcodeSettingQuery} variables={{accountId: accountID}}>
          {({loading, error, data}) => {
            if (loading)
              return (
                <div>
                  <LoadingScreen size={50} />
                </div>
              )
            if (error) return <div>{t('barcode.wizard.template-drawer.error-loading')}</div>

            setBarcodeData(data['barcodeSetting'])
            if (barcodeValue === '' && props.template) {
              checkTemplate(data['barcodeSetting'])
            }

            return (
              <div>
                <FormControl component="fieldset" className={classes.formControl}>
                  <RadioGroup
                    aria-label="gender"
                    name="barcodeSettings"
                    value={barcodeValue}
                    onChange={handleChange}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        {t('barcode.wizard.template-drawer.automatic-generate')}
                      </Grid>
                      <Grid item xs={12}>
                        {barcodeData.map((record, index) => {
                          if (record.dataSource === 'automated') {
                            if (props.reprint && record.lastPrinted === '-') {
                              return ''
                            } else {
                              return (
                                <div className={classes.borderStyle} key={record.id}>
                                  <FormControlLabel
                                    value={`${index}unique`}
                                    control={<Radio />}
                                    label={record.name}
                                    className={classes.radioSpacing}
                                  />
                                </div>
                              )
                            }
                          }
                          return ''
                        })}
                      </Grid>
                    </Grid>

                    <Box marginTop={2} />
                    <Grid container spacing={2} hidden={props.reprint}>
                      <Grid item xs={12}>
                        {t('barcode.wizard.template-drawer.field-generate')}
                      </Grid>
                      <Grid item xs={12}>
                        <Box marginLeft={1}>
                          {barcodeData.map((record, index) => {
                            if (record.dataSource === 'from_objects') {
                              return (
                                <div className={classes.borderStyle} key={record.id}>
                                  <FormControlLabel
                                    value={`${index}unique`}
                                    control={<Radio />}
                                    label={record.name}
                                    className={classes.radioSpacing}
                                  />
                                </div>
                              )
                            }
                            return ''
                          })}
                        </Box>
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </div>
            )
          }}
        </Query>

        <Box marginTop={2} />
        <Grid container item xs={12}>
          <Button
            value="save-template"
            variant="contained"
            color="primary"
            fullWidth={true}
            disabled={!validateBarcodePermission(currentUser, "can_generate")}
            onClick={redirectBarcodeGenerate}
          >
            {t('barcode.wizard.template-drawer.generate-barcodes')}
          </Button>
          <Button
            id="generate-redirect"
            hidden
            component={Link}
            to={{
              pathname: generateLink,
              state: {
                barcodeData: selectedRecord,
                previous: false,
                generatePage: true,
              },
            }}
          />
        </Grid>
        <Box marginTop={2} />
        <Grid container item xs={12} justify="flex-start">
          <Button value="save-template" variant="outlined" fullWidth={true} onClick={closeDrawer}>
            {t('barcode.wizard.template-drawer.cancel')}
          </Button>
        </Grid>
        <Box marginBottom={5} />
      </Container>
    </div>
  )
}
